async function fetchCartData() {
  const response = await fetch("/cart.js");
  return await response.json();
}
async function sendAddToCart(items) {
  let itemsWithPreOrder = items;
  console.log("sendAddToCart", items, items[0].pre_order_dispatch_eta);
  if (items[0].pre_order === "true") {
    let formatDispatchDate = function(isoDate) {
      if (!isoDate)
        return "";
      const parts = isoDate.split("-").map((p) => parseInt(p, 10));
      if (parts.length !== 3)
        return isoDate;
      const [year, month, day] = parts;
      if (isNaN(year) || isNaN(month) || isNaN(day))
        return isoDate;
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const getOrdinal = (d) => {
        const v = d % 100;
        if (v >= 11 && v <= 13)
          return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };
      const monthName = monthNames[Math.max(0, Math.min(11, month - 1))];
      return `${day}${getOrdinal(day)} ${monthName} ${year}`;
    };
    const preOrderDateField = items[0].pre_order_dispatch_eta ? items[0].pre_order_dispatch_eta : "";
    const formattedPreOrderDispatchDate = typeof preOrderDateField === "string" ? formatDispatchDate(preOrderDateField) : "";
    const preOrderShipDate = window.themeVars.strings.cart.preOrderShipDate.replace(
      "{{ date }}",
      formattedPreOrderDispatchDate
    );
    itemsWithPreOrder = items.map((item) => ({
      ...item,
      properties: {
        ...item.properties || {},
        "_pre_order": "true",
        "Estimated Dispatch Date": preOrderShipDate
      }
    }));
  }
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ items: itemsWithPreOrder })
  });
  const cart = await response.json();
  if (cart.error || cart.status) {
    console.error(
      `Cart.sendAddToCart() : ${cart.description || cart.message || "Unknown error"}`
    );
  } else {
    const updatedCartData = await fetchCartData();
    document.dispatchEvent(
      new CustomEvent("cart:added", { detail: updatedCartData })
    );
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: updatedCartData })
    );
  }
}
document.addEventListener("cart:updated", handlePfandCheck);
async function handlePfandCheck() {
  const updatedCartData = await fetchCartData();
  const pfandCharge = updatedCartData.items.find(
    (item) => item.title === "Pfand"
  );
  const hasPfandPerItem = updatedCartData.items.some(
    (item) => item.properties && item.properties["Pfand"]
  );
  if (updatedCartData.items.length === 1 && pfandCharge || !hasPfandPerItem && pfandCharge) {
    await removePfandCharge(pfandCharge);
  }
  if (hasPfandPerItem && !pfandCharge) {
    await addPfandChargeWithExistingFunction();
  }
}
async function removePfandCharge(pfandCharge) {
  if (!pfandCharge) {
    return;
  }
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: pfandCharge.key,
      quantity: 0
    })
  });
  const updatedCartData = await response.json();
  document.dispatchEvent(
    new CustomEvent("cart:updated", { detail: updatedCartData })
  );
}
async function addPfandChargeWithExistingFunction() {
  const pfandChargeVariantId = window.themeVars.config.pfandProduct;
  if (!pfandChargeVariantId) {
    return;
  }
  await sendAddToCart([
    {
      id: pfandChargeVariantId,
      quantity: 1,
      properties: {},
      selling_plan: ""
    }
  ]);
}
export {
  fetchCartData as f,
  sendAddToCart as s
};
